(function () {
  'use strict';

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  var MiniCart = {
    init: function () {
      if (this.bound) return;
      this.bound = true;
      this.isOpen = false;
      document.addEventListener('click', this.onClick.bind(this));
      document.addEventListener('submit', this.onSubmit.bind(this));
      document.addEventListener('keyup', function (evt) {
        if (evt.key === 'Escape') this.close();
      }.bind(this));
      document.addEventListener('voost:cart:refresh', function (evt) {
        this.refresh().then(function () {
          if (evt.detail && evt.detail.open) this.open();
        }.bind(this));
      }.bind(this));
    },
    container: function () {
      return document.querySelector('[data-cart-drawer]');
    },
    sectionId: function () {
      var container = this.container();
      var section = container && container.closest('.shopify-section');
      return section ? section.id.replace('shopify-section-', '') : null;
    },
    onClick: function (evt) {
      var target = evt.target;
      if (target.closest('.js-drawer-open-cart') || target.closest('[data-open-cart]')) {
        evt.preventDefault();
        this.open();
        return;
      }
      if (target.closest('[data-mini-cart-close]') || target.closest('[data-cart-drawer] .overlay')) {
        this.close();
        return;
      }
      if (target.closest('[data-mini-cart-clear]')) {
        evt.preventDefault();
        this.clear();
      }
    },
    onSubmit: function (evt) {
      var form = evt.target;
      if (!form.matches || !form.matches('form[action*="/cart/add"]') || form.hasAttribute('data-product-selector-form')) return;
      evt.preventDefault();
      var submit = form.querySelector('[type="submit"]');
      if (submit) submit.setAttribute('aria-busy', 'true');
      fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form)
      })
        .then(function (response) {
          if (!response.ok) throw new Error('add failed');
          return this.refresh();
        }.bind(this))
        .then(function () {
          this.open();
        }.bind(this))
        .catch(function () {
          form.submit();
        })
        .finally(function () {
          if (submit) submit.removeAttribute('aria-busy');
        });
    },
    open: function () {
      var container = this.container();
      if (!container) return;
      var panel = container.querySelector('.mini-cart');
      if (!container.querySelector('.overlay')) {
        var overlay = document.createElement('div');
        overlay.className = 'overlay overlay--dark';
        container.insertBefore(overlay, panel);
      }
      panel.classList.add('mini-cart--open');
      document.body.classList.add('overflow-hidden-tablet');
      this.isOpen = true;
    },
    close: function () {
      var container = this.container();
      if (!container || !this.isOpen) return;
      var panel = container.querySelector('.mini-cart');
      var overlay = container.querySelector('.overlay');
      if (overlay) overlay.remove();
      if (panel) panel.classList.remove('mini-cart--open');
      document.body.classList.remove('overflow-hidden-tablet');
      this.isOpen = false;
    },
    clear: function () {
      return fetch(root + 'cart/clear.js', { method: 'POST', headers: { Accept: 'application/json' } }).then(this.refresh.bind(this));
    },
    refresh: function () {
      var id = this.sectionId();
      if (!id) return Promise.resolve();
      return fetch(root + '?sections=' + encodeURIComponent(id))
        .then(function (response) {
          return response.json();
        })
        .then(function (data) {
          var doc = new DOMParser().parseFromString(data[id], 'text/html');
          var fresh = doc.querySelector('[data-cart-drawer]');
          var current = this.container();
          if (fresh && current) {
            current.innerHTML = fresh.innerHTML;
            if (this.isOpen) {
              this.isOpen = false;
              this.open();
            }
          }
          var freshCount = doc.querySelector('[data-cart-count]');
          document.querySelectorAll('[data-cart-count]').forEach(function (bubble) {
            if (!freshCount) return;
            bubble.className = freshCount.className;
            bubble.textContent = freshCount.textContent;
          });
        }.bind(this));
    }
  };

  var SubscriptionWidget = {
    init: function () {
      this.render();
      if (this.bound) return;
      this.bound = true;
      document.addEventListener('variant:change', function () {
        this.render();
        setTimeout(this.render.bind(this), 150);
      }.bind(this));
      setTimeout(this.render.bind(this), 400);
      document.addEventListener('change', function (evt) {
        var radio = evt.target.closest && evt.target.closest('.shopify_subscriptions_app_block input[type="radio"]');
        var section = radio && radio.closest('.shopify_subscriptions_app_block');
        if (section) this.selectOption(section, radio);
        if (evt.target.closest && evt.target.closest('.shopify_subscriptions_app_block')) this.render();
      }.bind(this));
      document.addEventListener('click', function (evt) {
        var card = evt.target.closest && evt.target.closest('.shopify_subscriptions_app_block_label');
        if (!card) return;
        if (evt.target.closest('label') || evt.target.tagName === 'INPUT' || evt.target.closest('a')) return;
        var radio = card.querySelector('label input[type="radio"]');
        if (radio && !radio.checked) radio.click();
      });
      var container = document.querySelector('.shopify_subscriptions_app_block_container');
      if (container && 'MutationObserver' in window) {
        new MutationObserver(this.render.bind(this)).observe(container, {
          childList: true,
          subtree: true,
          attributes: true,
          attributeFilter: ['class']
        });
      }
    },
    money: function (value) {
      return String(value || '').replace(/\s+[A-Z]{3}$/, '').trim();
    },
    priceFrom: function (scope, id) {
      var el = scope.querySelector('script[id="' + id + '"]');
      if (!el) return null;
      try {
        return JSON.parse(el.textContent);
      } catch (e) {
        return null;
      }
    },
    priceMarkup: function (data, unit) {
      if (!data || !data.price) return null;
      var wrap = document.createElement('span');
      wrap.className = 'subs-price';
      var compare = this.money(data.comparedAtPrice);
      var price = this.money(data.price);
      if (compare && compare !== price) {
        var old = document.createElement('s');
        old.className = 'subs-price__compare';
        old.textContent = compare;
        wrap.appendChild(old);
      }
      var now = document.createElement('span');
      now.className = 'subs-price__now';
      now.textContent = price;
      wrap.appendChild(now);
      if (unit) {
        var unitEl = document.createElement('span');
        unitEl.className = 'subs-price__unit';
        unitEl.textContent = unit;
        wrap.appendChild(unitEl);
      }
      return wrap;
    },
    decorate: function (labelBox, data, unit) {
      if (!labelBox || labelBox.dataset.subsPriced === (data && data.price)) return;
      var label = labelBox.querySelector(':scope > label');
      if (!label) return;
      var existing = label.querySelector('.subs-price');
      if (existing) existing.remove();
      var price = this.priceMarkup(data, unit);
      if (!price) return;
      label.classList.add('subs-row');
      label.appendChild(price);
      labelBox.dataset.subsPriced = data.price;
    },
    selectOption: function (section, radio) {
      var pair = [radio];
      var type = radio.dataset.radioType;
      if (type === 'selling_plan_group') {
        var child = section.querySelector('input[data-radio-type="selling_plan"]');
        if (child) pair.push(child);
      } else if (type === 'selling_plan' && radio.dataset.sellingPlanGroupId) {
        var parent = section.querySelector('input[id="' + radio.dataset.sellingPlanGroupId + '"]');
        if (parent) pair.push(parent);
      }
      section.querySelectorAll('input[type="radio"]').forEach(function (other) {
        other.checked = pair.indexOf(other) > -1;
      });
      this.syncPlan(section);
    },

    syncPlan: function (section) {
      if (section.classList.contains('shopify_subscriptions_app_block--hidden')) return;
      var form = section.closest('form[data-product-selector-form]');
      if (!form) return;
      var checked = section.querySelector('input[type="radio"]:checked');
      var planId = '';
      if (checked) {
        if (checked.dataset.radioType === 'selling_plan') {
          planId = checked.dataset.sellingPlanId || '';
        } else if (checked.dataset.radioType === 'selling_plan_group') {
          var child = section.querySelector('input[data-radio-type="selling_plan"]');
          planId = (child && child.dataset.sellingPlanId) || '';
        }
      }
      var input = form.querySelector('input[name="selling_plan"][data-subs-plan]');
      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'selling_plan';
        input.setAttribute('data-subs-plan', '');
        form.appendChild(input);
      }
      input.value = planId;
    },

    render: function () {
      document.querySelectorAll('.shopify_subscriptions_app_block').forEach(this.syncPlan, this);
      var mount = document.querySelector('[data-subscription-settings]');
      var unit = mount ? mount.getAttribute('data-subscription-unit') : '';
      var title = mount ? mount.getAttribute('data-subscription-title') : 'Select Your Purchase Type';
      document.querySelectorAll('.shopify_subscriptions_app_block').forEach(function (section) {
        var options = section.querySelector('.shopify_subscriptions_app_block_purchase_options');
        if (!options) return;
        if (title && !section.querySelector('.subs-title')) {
          var heading = document.createElement('p');
          heading.className = 'subs-title';
          heading.textContent = title;
          options.parentNode.insertBefore(heading, options);
        }
        var variantId = section.getAttribute('data-variant-id');
        var oneTime = section.querySelector('input[data-radio-type="one_time_purchase"]');
        if (oneTime) {
          this.decorate(
            oneTime.closest('.shopify_subscriptions_app_block_label'),
            this.priceFrom(section, 'subscriptions_money_with_currency_one_time_purchase_' + variantId),
            unit
          );
        }
        var plan = section.querySelector('input[data-radio-type="selling_plan"]');
        if (plan) {
          var id = 'subscriptions_money_with_currency_' + plan.dataset.sellingPlanGroupId + '_' + plan.dataset.sellingPlanId;
          this.decorate(plan.closest('.shopify_subscriptions_app_block_label'), this.priceFrom(section, id), unit);
        }
        var benefits = mount && mount.querySelector('[data-subscription-benefits]');
        var planBox = plan && plan.closest('.shopify_subscriptions_app_block_label');
        if (benefits && planBox && !planBox.querySelector('.subs-benefits')) {
          var list = document.createElement('ul');
          list.className = 'subs-benefits';
          benefits.querySelectorAll('li').forEach(function (item) {
            var li = document.createElement('li');
            li.innerHTML = item.innerHTML;
            list.appendChild(li);
          });
          if (list.children.length) planBox.appendChild(list);
        }
      }, this);
    }
  };

  var Animations = {
    init: function (scope) {
      var sections = (scope || document).querySelectorAll('[a-animate-section]:not(.animated)');
      if (!('IntersectionObserver' in window)) {
        sections.forEach(function (el) {
          el.classList.add('animated');
        });
        return;
      }
      if (!this.observer) {
        this.observer = new IntersectionObserver(function (entries) {
          var entry = entries[0];
          if (entry && entry.isIntersecting) entry.target.classList.add('animated');
        }, { root: null, rootMargin: '0px', threshold: 0.3 });
      }
      sections.forEach(function (el) {
        this.observer.observe(el);
        var rect = el.getBoundingClientRect();
        if (rect.top < window.innerHeight && rect.bottom > 0) el.classList.add('animated');
      }, this);
    }
  };

  class AccordionItem extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      this.addEventListener('click', this.onClick.bind(this));
      if (this.classList.contains('active')) {
        this.setContent(this.querySelector('[data-accordion-content]'), true);
      }
    }
    onClick(evt) {
      var heading = evt.target.closest('.accordion__heading');
      if (!heading) return;
      evt.preventDefault();
      var current = document.querySelector('accordion-item.active');
      if (current && current !== this) {
        current.setContent(current.querySelector('[data-accordion-content]'), false);
        current.classList.remove('active');
      }
      this.classList.toggle('active');
      this.setContent(heading.nextElementSibling, this.classList.contains('active'));
    }
    setContent(content, open) {
      if (!content) return;
      content.style.height = (open ? content.scrollHeight + 30 : 0) + 'px';
    }
  }

  class SwiperSection extends HTMLElement {
    connectedCallback() {
      this.carousel = this.querySelector('[data-carousel]');
      if (!this.carousel || typeof window.Swiper !== 'function') return;
      if (this.carousel.swiper) this.carousel.swiper.destroy(true, true);
      this.swiper = new window.Swiper(this.carousel, this.options());
    }
    disconnectedCallback() {
      if (this.swiper) this.swiper.destroy(true, true);
      this.swiper = null;
    }
    options() {
      return {};
    }
  }

  class ImageGrid extends SwiperSection {
    options() {
      return { slidesPerView: 1.1, spaceBetween: 12 };
    }
  }

  class VideoCarousel extends SwiperSection {
    connectedCallback() {
      this.fillLoop();
      super.connectedCallback();
      if (this.bound) return;
      this.bound = true;
      this.querySelectorAll('[data-play-button]').forEach(function (button) {
        button.addEventListener('click', function () {
          var video = button.closest('[data-video-wrapper]').querySelector('video');
          if (!video) return;
          if (video.paused) {
            this.pauseAll();
            video.play();
            button.style.opacity = '0';
            video.controls = true;
          } else {
            video.pause();
            button.style.opacity = '1';
            video.controls = false;
          }
          video.onpause = function () {
            button.style.opacity = '1';
            video.controls = false;
          };
        }.bind(this));
      }, this);
    }
    pauseAll() {
      this.querySelectorAll('[data-video-wrapper]').forEach(function (wrapper) {
        var video = wrapper.querySelector('video');
        if (video && !video.paused) {
          video.pause();
          var button = wrapper.querySelector('[data-play-button]');
          if (button) button.style.opacity = '1';
          video.controls = false;
        }
      });
    }
    fillLoop() {
      var wrapper = this.querySelector('.swiper-wrapper');
      if (!wrapper || wrapper.dataset.filled) return;
      var originals = Array.from(wrapper.children);
      if (originals.length < 2) return;
      wrapper.dataset.filled = 'true';
      var copies = Math.ceil(12 / originals.length) - 1;
      for (var i = 0; i < copies; i++) {
        originals.forEach(function (slide) {
          var clone = slide.cloneNode(true);
          clone.setAttribute('data-clone', '');
          clone.querySelectorAll('video').forEach(function (video) {
            video.preload = 'none';
          });
          wrapper.appendChild(clone);
        });
      }
    }
    options() {
      return {
        slidesPerView: 1.4,
        centeredSlides: true,
        spaceBetween: 12,
        loop: this.querySelectorAll('.swiper-slide').length > 1,
        breakpoints: { 992: { slidesPerView: 4.6 } },
        on: { slideChange: this.pauseAll.bind(this) }
      };
    }
  }

  class TestimonialSlider extends SwiperSection {
    connectedCallback() {
      super.connectedCallback();
      this.initMarquee();
    }
    options() {
      return {
        slidesPerView: 1,
        spaceBetween: 20,
        loop: true,
        navigation: { nextEl: this.querySelector('[data-next]'), prevEl: this.querySelector('[data-prev]') },
        breakpoints: { 992: { slidesPerView: 3, allowTouchMove: false } }
      };
    }
    initMarquee() {
      var marquee = this.querySelector('[data-marquee]');
      if (!marquee || !marquee.children.length || marquee.dataset.ready) return;
      marquee.dataset.ready = 'true';
      var children = Array.from(marquee.children);
      var half = Math.floor(children.length / 2);
      if (half < 1) return;
      var originals = children.slice(0, half);
      var guard = 30;
      while (marquee.scrollWidth < 2 * window.innerWidth && guard-- > 0) {
        originals.forEach(function (child) {
          marquee.appendChild(child.cloneNode(true));
        });
      }
      var sets = marquee.children.length / half;
      marquee.style.setProperty('--marquee-end', '-' + (100 / sets).toFixed(4) + '%');
    }
  }

  function postJSON(url, data) {
    return fetch(root + url.replace(/^\//, ''), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(data || {})
    }).then(function (response) {
      return response.json().catch(function () {
        return {};
      }).then(function (json) {
        if (!response.ok) {
          var error = new Error(json.description || json.message || 'Request failed');
          error.status = response.status;
          throw error;
        }
        return json;
      });
    });
  }

  function slideToggle(el, open) {
    if (!el) return;
    if (open) {
      el.style.display = 'block';
      var target = el.scrollHeight;
      el.style.overflow = 'hidden';
      el.style.transition = '';
      el.style.height = '0px';
      void el.offsetHeight;
      requestAnimationFrame(function () {
        el.style.transition = 'height .4s ease';
        el.style.height = target + 'px';
      });
      setTimeout(function () {
        el.style.height = '';
        el.style.overflow = '';
        el.style.transition = '';
      }, 420);
    } else {
      el.style.overflow = 'hidden';
      el.style.height = el.scrollHeight + 'px';
      requestAnimationFrame(function () {
        el.style.transition = 'height .4s ease';
        el.style.height = '0px';
      });
      setTimeout(function () {
        el.style.display = 'none';
        el.style.height = '';
        el.style.overflow = '';
        el.style.transition = '';
      }, 420);
    }
  }

  class ProductSelector extends HTMLElement {
    connectedCallback() {
      if (this.initialized) {
        this.initSwipers();
        return;
      }
      this.initialized = true;
      var cfgEl = this.querySelector('[data-product-selector-config]');
      try {
        this.cfg = cfgEl ? JSON.parse(cfgEl.textContent) : {};
      } catch (e) {
        this.cfg = {};
      }
      this.sectionId = this.cfg.sectionId || this.dataset.sectionId;
      this.boxes = Array.from(this.querySelectorAll('.bundle-offerss .offer-box'));
      this.atc = this.querySelector('[data-add-to-cart]');
      this.otp = this.querySelector('[data-otp-purchase]');
      this.errorEl = this.querySelector('.product-selector__error');
      this.setInitialOffer();
      this.initSwipers();
      this.initOrderDate();
      this.initSoldBar();
      this.initFaq();
      this.initOffers();
      ProductSelector.placeScrollAnchor();
    }

    disconnectedCallback() {
      if (this.soldRaf) cancelAnimationFrame(this.soldRaf);
      this.querySelectorAll('.swiper').forEach(function (el) {
        if (el.swiper) el.swiper.destroy(true, true);
      });
    }

    activeBox() {
      return this.querySelector('.bundle-offerss .offer-box.active') || this.boxes[0];
    }

    setInitialOffer() {
      if (!this.boxes.length) return;
      var index = -1;
      if (this.cfg.urlParam && !this.cfg.purchaseModuleOnly) {
        var params = new URLSearchParams(window.location.search);
        var variantId = (params.get('variant') || '').trim();
        if (variantId) {
          index = this.boxes.findIndex(function (box) {
            return box.dataset.variantId === variantId;
          });
        }
        if (index < 0) {
          var count = parseInt(params.get('count'), 10);
          if (count >= 1 && count <= this.boxes.length) index = count - 1;
        }
      }
      if (index < 0) {
        index = this.boxes.findIndex(function (box) {
          return box.classList.contains('active');
        });
      }
      if (index < 0) index = 0;
      this.boxes.forEach(function (box, i) {
        box.classList.toggle('active', i === index);
      });
    }

    initSwipers() {
      if (typeof window.Swiper !== 'function') return;
      var main = this.querySelector('.product-swiper-main');
      var thumbs = this.querySelector('.product-swiper-thumbs');
      if (main && thumbs) {
        if (main.swiper) main.swiper.destroy(true, true);
        if (thumbs.swiper) thumbs.swiper.destroy(true, true);
        var thumbSwiper = new window.Swiper(thumbs, { slidesPerView: 5, spaceBetween: 4, watchSlidesProgress: true, slideToClickedSlide: true });
        new window.Swiper(main, {
          slidesPerView: 1,
          spaceBetween: 0,
          loop: main.querySelectorAll('.swiper-slide').length > 1,
          navigation: { nextEl: this.querySelector('.swiper-thumb-next'), prevEl: this.querySelector('.swiper-thumb-prev') },
          thumbs: { swiper: thumbSwiper }
        });
      }
      var videos = this.querySelector('#oo-vt-swiper-desk-' + this.sectionId);
      if (videos) {
        if (videos.swiper) videos.swiper.destroy(true, true);
        var count = parseInt(this.cfg.vtCount, 10) || 0;
        new window.Swiper(videos, {
          slidesPerView: 3,
          spaceBetween: 16,
          loop: count > 3,
          navigation: { prevEl: this.querySelector('#oo-vt-prev-desk-' + this.sectionId), nextEl: this.querySelector('#oo-vt-next-desk-' + this.sectionId) }
        });
        videos.querySelectorAll('.custom-play-button').forEach(function (button) {
          if (button.dataset.bound) return;
          button.dataset.bound = 'true';
          button.addEventListener('click', function () {
            var video = button.closest('.video-wrapper').querySelector('video');
            if (!video) return;
            if (video.paused) {
              video.play();
              button.style.opacity = '0';
            } else {
              video.pause();
              button.style.opacity = '1';
            }
          });
        });
      }
    }

    initOrderDate() {
      var el = this.querySelector('.order-date .date-text');
      if (!el) return;
      var days = parseInt(el.dataset.deliveryDays || this.cfg.deliveryDays, 10) || 3;
      var date = new Date();
      date.setDate(date.getDate() + days);
      var weekday = date.toLocaleString('default', { weekday: 'short' });
      var month = date.toLocaleString('default', { month: 'short' });
      el.textContent = weekday + ', ' + month + ' ' + date.getDate();
    }

    initSoldBar() {
      var bar = this.querySelector('.sold-progress-bar');
      if (!bar) return;
      var fill = bar.querySelector('.sold-progress-bar__fill');
      var text = bar.querySelector('.sold-progress-bar__percentage');
      var target = parseInt(bar.dataset.soldPercent, 10);
      var label = bar.dataset.soldLabel || '';
      if (!fill || !Number.isFinite(target) || target < 0) return;
      fill.style.width = '0%';
      if (text) text.textContent = '0% ' + label;
      requestAnimationFrame(function () {
        fill.style.width = '';
        var start = performance.now();
        var step = function (now) {
          var progress = Math.min(1, (now - start) / 5000);
          var value = Math.round(target * (1 - Math.pow(1 - progress, 3)));
          if (text) text.textContent = value + '% ' + label;
          if (progress < 1) this.soldRaf = requestAnimationFrame(step);
        }.bind(this);
        this.soldRaf = requestAnimationFrame(step);
      }.bind(this));
    }

    initFaq() {
      var items = this.querySelectorAll('.faq-items');
      items.forEach(function (item) {
        var button = item.querySelector('.faq-questions');
        if (!button) return;
        var icon = button.querySelector('.toggle-icons');
        var answer = item.querySelector('.faq-answers');
        button.addEventListener('click', function () {
          var isOpen = item.classList.contains('active');
          items.forEach(function (other) {
            other.classList.remove('active');
            var otherButton = other.querySelector('.faq-questions');
            if (otherButton) otherButton.classList.remove('active');
            var otherIcon = other.querySelector('.toggle-icons');
            if (otherIcon) otherIcon.textContent = '+';
            var otherAnswer = other.querySelector('.faq-answers');
            if (otherAnswer && otherAnswer !== answer) slideToggle(otherAnswer, false);
          });
          if (isOpen) {
            slideToggle(answer, false);
          } else {
            item.classList.add('active');
            button.classList.add('active');
            if (icon) icon.textContent = '–';
            slideToggle(answer, true);
          }
        });
      });
    }

    initOffers() {
      this.boxes.forEach(function (box) {
        box.addEventListener('click', function () {
          this.selectBox(box);
        }.bind(this));
      }, this);
      if (this.atc) this.atc.addEventListener('click', this.onAddToCart.bind(this));
      if (this.otp) this.otp.addEventListener('click', this.onOneTime.bind(this));
      var form = this.querySelector('[data-product-selector-form]');
      if (form) {
        form.addEventListener('submit', function (evt) {
          evt.preventDefault();
          evt.stopPropagation();
          if (this.atc && !this.atc.disabled) this.atc.click();
        }.bind(this));
      }
      this.update();
    }

    selectBox(box) {
      if (!box || box.classList.contains('active')) return;
      this.boxes.forEach(function (b) {
        b.classList.toggle('active', b === box);
      });
      this.update();
      this.swapHero(box);
      if (this.cfg.urlParam && !this.cfg.purchaseModuleOnly) {
        var params = new URLSearchParams(window.location.search);
        params.delete('count');
        if (box.dataset.variantId) {
          params.set('variant', box.dataset.variantId);
        } else {
          params.delete('variant');
        }
        var query = params.toString();
        window.history.replaceState({}, '', window.location.pathname + (query ? '?' + query : ''));
      }
    }

    update() {
      var box = this.activeBox();
      if (!box) return;
      var d = box.dataset;
      var isSub = !!(d.sellingPlanId && d.sellingPlanId !== '0');
      var price = isSub ? d.perDeliveryPrice : d.price;
      var compare = d.comparePrice || '';
      var save = isSub ? d.saveDeliveryPrice : d.savePrice;
      var available = d.available !== 'false';

      var row = this.querySelector('.price-rows');
      if (row) {
        var rowPrice = row.querySelector('.price');
        var rowCompare = row.querySelector('.compare-price');
        var rowSave = row.querySelector('.save-label');
        if (rowPrice) rowPrice.textContent = price;
        if (rowCompare) {
          rowCompare.textContent = compare;
          rowCompare.style.display = compare ? '' : 'none';
        }
        if (rowSave) rowSave.style.display = compare ? '' : 'none';
        var saveEl = this.querySelector('#sav-price-' + this.sectionId);
        if (saveEl) saveEl.textContent = save;
      }
      var label = this.querySelector('.subscription-price-label');
      if (label) label.textContent = isSub ? label.dataset.subLabel : label.dataset.otpLabel;

      this.querySelectorAll('.add-to-cart-button .main-price').forEach(function (el) {
        el.textContent = price;
      });
      this.querySelectorAll('.add-to-cart-button .compare-price').forEach(function (el) {
        el.textContent = compare;
        el.style.display = compare ? '' : 'none';
      });
      if (this.atc && !this.atc.classList.contains('loading_hk')) {
        this.atc.disabled = !available;
        var atcLabel = this.atc.querySelector('.atcr-label');
        if (atcLabel) atcLabel.textContent = available ? this.atc.dataset.addLabel : this.atc.dataset.soldOutLabel;
      }

      var input = this.querySelector('#ofer-sec2-' + this.sectionId + ' input[name="id"]');
      if (input) {
        var nextId = d.variantId || '';
        var changed = input.value !== nextId;
        input.value = nextId;
        if (changed) {
          input.dispatchEvent(new Event('change', { bubbles: true }));
          document.dispatchEvent(new CustomEvent('variant:change', {
            bubbles: true,
            detail: { variant: { id: parseInt(nextId, 10) }, sectionId: this.sectionId }
          }));
        }
      }

      if (this.otp && !this.otp.classList.contains('loading_hk')) {
        var otpText = this.otp.querySelector('[data-otp-link-text]');
        this.otp.dataset.variantId = d.otpVariantId || '';
        this.otp.dataset.quantity = d.quantity || '1';
        this.otp.disabled = !d.otpVariantId || d.otpAvailable !== 'true';
        if (otpText) otpText.textContent = (this.otp.dataset.template || '').replace(/\[price\]/g, d.otpPrice || '');
      }

      this.boxes.forEach(function (b) {
        var active = b === box;
        b.querySelectorAll('.offer-gift-callout').forEach(function (el) {
          el.style.display = active ? 'flex' : 'none';
        });
      });

      var index = this.boxes.indexOf(box) + 1;
      var ggd = this.querySelector('[data-ggd-box]');
      if (ggd) {
        ggd.dataset.ggdActive = String(index);
        ggd.querySelectorAll('.ggd-item').forEach(function (item) {
          var unlock = parseInt(item.dataset.ggdUnlock, 10) || 1;
          item.classList.toggle('ggd-locked', unlock > index);
        });
      }
    }

    swapHero(box) {
      var main = box.dataset.heroImageMain;
      var thumb = box.dataset.heroImageThumb;
      if (main) {
        var mainImg = this.querySelector('[data-hero-slide="main"] img');
        if (mainImg) {
          mainImg.src = main;
          mainImg.removeAttribute('srcset');
        }
      }
      if (thumb) {
        var thumbImg = this.querySelector('[data-hero-slide="thumb"] img');
        if (thumbImg) {
          thumbImg.src = thumb;
          thumbImg.removeAttribute('srcset');
        }
      }
      if (main || thumb) {
        var mainSwiper = this.querySelector('.product-swiper-main');
        var thumbSwiper = this.querySelector('.product-swiper-thumbs');
        if (mainSwiper && mainSwiper.swiper) mainSwiper.swiper.slideToLoop(0);
        if (thumbSwiper && thumbSwiper.swiper) thumbSwiper.swiper.slideTo(0);
      }
    }

    setBusy(button, busy) {
      if (!button) return;
      button.classList.toggle('loading_hk', busy);
      button.disabled = busy;
      button.setAttribute('aria-busy', busy ? 'true' : 'false');
    }

    showError(message) {
      if (!this.errorEl) return;
      this.errorEl.textContent = message || '';
      this.errorEl.hidden = !message;
    }

    appSellingPlan() {
      var form = this.querySelector('[data-product-selector-form]');
      if (!form) return null;
      var field = form.querySelector('input[name="selling_plan"][data-subs-plan]') ||
        form.querySelector('input[name="selling_plan"]:checked, select[name="selling_plan"], input[name="selling_plan"]:not([type="radio"]):not([type="checkbox"])');
      if (!field) return null;
      var value = parseInt(field.value, 10);
      return value ? value : null;
    }

    itemsForBox(box) {
      var d = box.dataset;
      var planId = d.sellingPlanId && d.sellingPlanId !== '0' ? parseInt(d.sellingPlanId, 10) : null;
      planId = this.appSellingPlan() || planId;
      var item = { id: parseInt(d.variantId, 10), quantity: parseInt(d.quantity, 10) || 1 };
      if (planId) item.selling_plan = planId;
      var code = (d.discountCode || '').trim();
      if (code) item.properties = { _offer_discount: code };
      var items = [item];
      box.querySelectorAll('.pdp-main__offer-gift').forEach(function (gift) {
        var id = parseInt(gift.dataset.giftId, 10);
        if (id) items.push({ id: id, quantity: parseInt(gift.dataset.giftQuantity, 10) || 1 });
      });
      return items;
    }

    addItems(items, codes, button) {
      var clearFirst = button && button.dataset.clearCart === 'true';
      var after = (button && button.dataset.afterAdd) || 'checkout';
      this.showError('');
      this.setBusy(button, true);
      var chain = clearFirst ? postJSON('cart/clear.js') : Promise.resolve();
      return chain
        .then(function () {
          return postJSON('cart/add.js', { items: items });
        })
        .then(function () {
          if (!codes.length) return null;
          return postJSON('cart/update.js', { discount: codes.join(',') }).catch(function () {
            return null;
          });
        })
        .then(function () {
          if (after === 'drawer') {
            document.dispatchEvent(new CustomEvent('voost:cart:refresh', { detail: { open: true } }));
            this.setBusy(button, false);
            this.update();
            return;
          }
          if (after === 'cart') {
            window.location.href = root + 'cart';
            return;
          }
          window.location.href = root + 'checkout' + (codes.length ? '?discount=' + codes.map(encodeURIComponent).join(',') : '');
        }.bind(this))
        .catch(function (error) {
          this.setBusy(button, false);
          this.update();
          this.showError(error && error.message ? error.message : 'Could not add to cart.');
        }.bind(this));
    }

    onAddToCart() {
      if (!this.atc || this.atc.disabled) return;
      var box = this.activeBox();
      if (!box) {
        var input = this.querySelector('#ofer-sec2-' + this.sectionId + ' input[name="id"]');
        var variantId = input ? parseInt(input.value, 10) : 0;
        if (!variantId) {
          this.showError('This product is not connected to a variant.');
          return;
        }
        var item = { id: variantId, quantity: 1 };
        var appPlan = this.appSellingPlan();
        if (appPlan) item.selling_plan = appPlan;
        this.addItems([item], [], this.atc);
        return;
      }
      if (!box.dataset.variantId) {
        this.showError('This offer is not connected to a product variant.');
        return;
      }
      var code = (box.dataset.discountCode || '').trim();
      this.addItems(this.itemsForBox(box), code ? [code] : [], this.atc);
    }

    onOneTime() {
      if (!this.otp || this.otp.disabled) return;
      var id = parseInt(this.otp.dataset.variantId, 10);
      if (!id) return;
      this.addItems([{ id: id, quantity: parseInt(this.otp.dataset.quantity, 10) || 1 }], [], this.otp);
    }

    static placeScrollAnchor() {
      var existing = document.getElementById('scroll-pro');
      if (existing && existing.classList.contains('dd-auto-anchor')) existing.remove();
      var sections = Array.from(document.querySelectorAll('.shopify-section')).filter(function (section) {
        return section.querySelector('.product-section');
      });
      if (!sections.length) return;
      var target = sections[sections.length - 1];
      var anchor = document.createElement('span');
      anchor.id = 'scroll-pro';
      anchor.className = 'dd-auto-anchor';
      anchor.style.cssText = 'display:block;position:relative;top:-80px;visibility:hidden;pointer-events:none;';
      target.insertBefore(anchor, target.firstChild);
    }
  }

  class CountdownBar extends HTMLElement {
    connectedCallback() {
      this.h = this.querySelector('[data-hours-value]');
      this.m = this.querySelector('[data-minutes-value]');
      this.s = this.querySelector('[data-seconds-value]');
      this.end = this.resolveEnd();
      this.tick();
      this.timer = setInterval(this.tick.bind(this), 1000);
    }
    disconnectedCallback() {
      clearInterval(this.timer);
    }
    resolveEnd() {
      if (this.dataset.mode === 'date' && this.dataset.end) {
        var parsed = Date.parse(this.dataset.end.replace(' ', 'T'));
        if (!isNaN(parsed)) return parsed;
      }
      var hours = parseFloat(this.dataset.hours) || 2;
      var key = 'voost-countdown-' + (this.dataset.key || '');
      var stored = null;
      try {
        stored = parseInt(window.localStorage.getItem(key), 10);
      } catch (e) {
        stored = null;
      }
      var now = Date.now();
      if (!stored || stored <= now) {
        stored = now + hours * 3600000;
        try {
          window.localStorage.setItem(key, String(stored));
        } catch (e) {
          stored = now + hours * 3600000;
        }
      }
      return stored;
    }
    tick() {
      var left = Math.max(0, this.end - Date.now());
      if (left <= 0) {
        if (this.hasAttribute('data-hide-when-done')) {
          var section = this.closest('.shopify-section');
          if (section) section.style.display = 'none';
          clearInterval(this.timer);
          return;
        }
        if (this.dataset.mode !== 'date') {
          this.end = this.resolveEnd();
          left = Math.max(0, this.end - Date.now());
        }
      }
      var total = Math.floor(left / 1000);
      var pad = function (n) {
        return (n < 10 ? '0' : '') + n;
      };
      if (this.h) this.h.textContent = pad(Math.floor(total / 3600));
      if (this.m) this.m.textContent = pad(Math.floor((total % 3600) / 60));
      if (this.s) this.s.textContent = pad(total % 60);
    }
  }

  var Pdp = {
    init: function (scope) {
      var el = scope || document;
      this.clinicalStats(el);
      this.compounds(el);
      this.reviewsSlider(el);
      this.benefits(el);
      this.journey(el);
      this.reasons(el);
      this.videoTestimonials(el);
      this.readMore(el);
    },
    clinicalStats: function (el) {
      el.querySelectorAll('.clinical-proven-section').forEach(function (section) {
        if (section.dataset.bound) return;
        section.dataset.bound = 'true';
        var parse = function (stat) {
          var raw = (stat.getAttribute('data-target') || '').trim();
          var match = raw.match(/^(\D*)([\d.,\s]+)(.*)$/);
          if (!match) return null;
          var numeric = match[2].replace(/[\s,]/g, '');
          var hasDecimal = numeric.indexOf('.') > -1;
          var target = hasDecimal ? parseFloat(numeric) : parseInt(numeric, 10);
          if (isNaN(target)) return null;
          var custom = (match[1] || '').length > 0 || (match[3] || '').length > 0;
          var suffix = custom ? match[3] || '' : stat.getAttribute('data-hide-percent') === 'true' ? '' : '%';
          var decimals = hasDecimal ? (numeric.split('.')[1] || '').length : 0;
          return {
            prefix: match[1] || '',
            target: target,
            suffix: suffix,
            format: function (value) {
              return decimals > 0 ? value.toLocaleString('en-US', { minimumFractionDigits: decimals, maximumFractionDigits: decimals }) : Math.round(value).toLocaleString('en-US');
            }
          };
        };
        var stats = section.querySelectorAll('.stat-percentage');
        stats.forEach(function (stat) {
          var p = parse(stat);
          if (p) stat.textContent = p.prefix + p.format(0) + p.suffix;
        });
        var run = function () {
          stats.forEach(function (stat) {
            if (stat.classList.contains('counted')) return;
            stat.classList.add('counted');
            var p = parse(stat);
            if (!p) return;
            var duration = p.target <= 100 ? 1000 : 1800;
            var start = performance.now();
            var step = function (now) {
              var t = Math.min((now - start) / duration, 1);
              stat.textContent = p.prefix + p.format((1 - (1 - t) * (1 - t)) * p.target) + p.suffix;
              if (t < 1) requestAnimationFrame(step);
              else stat.textContent = p.prefix + p.format(p.target) + p.suffix;
            };
            requestAnimationFrame(step);
          });
        };
        if (!('IntersectionObserver' in window)) {
          run();
          return;
        }
        var observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              run();
              observer.disconnect();
            }
          });
        }, { threshold: 0.3 });
        observer.observe(section);
      });
    },
    compounds: function (el) {
      el.querySelectorAll('.compounds-section').forEach(function (section) {
        if (section.dataset.bound) return;
        section.dataset.bound = 'true';
        var track = section.querySelector('.compounds-carousel-track');
        var slides = section.querySelectorAll('.compounds-carousel-slide');
        var prev = section.querySelector('.compounds-nav-prev');
        var next = section.querySelector('.compounds-nav-next');
        if (!track || !slides.length || !prev || !next) return;
        var index = 0;
        var render = function () {
          track.style.transform = 'translateX(calc(-' + index + ' * (85% + 16px)))';
        };
        prev.addEventListener('click', function () {
          index = index === 0 ? slides.length - 1 : index - 1;
          render();
        });
        next.addEventListener('click', function () {
          index = index === slides.length - 1 ? 0 : index + 1;
          render();
        });
      });
    },
    reviewsSlider: function (el) {
      el.querySelectorAll('[data-pdp-reviews]').forEach(function (section) {
        var swiperEl = section.querySelector('.ts-review-swiper');
        if (swiperEl && typeof window.Swiper === 'function') {
          if (swiperEl.swiper) swiperEl.swiper.destroy(true, true);
          new window.Swiper(swiperEl, {
            slidesPerView: 1,
            spaceBetween: 20,
            loop: true,
            navigation: { nextEl: section.querySelector('[data-ts-next]'), prevEl: section.querySelector('[data-ts-prev]') },
            breakpoints: { 768: { slidesPerView: 3 } }
          });
        }
        var track = section.querySelector('.ts-marquee-track');
        if (!track || !track.children.length || track.dataset.ready) return;
        track.dataset.ready = 'true';
        var all = Array.from(track.children);
        var half = Math.floor(all.length / 2);
        if (half < 1) return;
        var originals = all.slice(0, half);
        var guard = 30;
        while (track.scrollWidth < window.innerWidth * 2 && guard-- > 0) {
          originals.forEach(function (item) {
            track.appendChild(item.cloneNode(true));
          });
        }
        track.style.setProperty('--marquee-end', '-' + (100 / (track.children.length / half)).toFixed(4) + '%');
      });
    },
    benefits: function (el) {
      el.querySelectorAll('.proven-benefits-section').forEach(function (section) {
        if (section.dataset.bound) return;
        section.dataset.bound = 'true';
        var questions = section.querySelectorAll('.faq_question');
        questions.forEach(function (question) {
          question.addEventListener('click', function () {
            var isActive = question.classList.contains('active');
            questions.forEach(function (other) {
              if (other !== question && other.classList.contains('active')) {
                other.classList.remove('active');
                slideToggle(other.nextElementSibling, false);
              }
            });
            question.classList.toggle('active', !isActive);
            slideToggle(question.nextElementSibling, !isActive);
          });
        });
      });
    },
    journey: function (el) {
      if (!el.querySelector('.milestone-item')) return;
      var check = function () {
        document.querySelectorAll('.milestone-item').forEach(function (item) {
          var rect = item.getBoundingClientRect();
          item.classList.toggle('active', window.innerHeight >= rect.bottom + 200);
        });
      };
      if (!this.journeyBound) {
        this.journeyBound = true;
        window.addEventListener('scroll', check, { passive: true });
      }
      check();
    },
    reasons: function (el) {
      el.querySelectorAll('[data-reasons-swiper]').forEach(function (swiperEl) {
        if (typeof window.Swiper !== 'function') return;
        if (swiperEl.swiper) swiperEl.swiper.destroy(true, true);
        var section = swiperEl.closest('.benefits-section-wrapper');
        new window.Swiper(swiperEl, {
          slidesPerView: 1,
          spaceBetween: 12,
          loop: true,
          navigation: { prevEl: section.querySelector('[data-reasons-prev]'), nextEl: section.querySelector('[data-reasons-next]') },
          pagination: { el: section.querySelector('[data-reasons-pagination]'), clickable: true },
          breakpoints: { 768: { slidesPerView: 3, spaceBetween: 12 } }
        });
      });
    },
    videoTestimonials: function (el) {
      el.querySelectorAll('[data-video-testimonials]').forEach(function (swiperEl) {
        if (typeof window.Swiper !== 'function') return;
        if (swiperEl.swiper) swiperEl.swiper.destroy(true, true);
        var wrapper = swiperEl.closest('.testimonial-slider-wrapper');
        var swiper = new window.Swiper(swiperEl, {
          slidesPerView: 6,
          slidesPerGroup: 2,
          spaceBetween: 0,
          loop: true,
          pagination: { el: swiperEl.querySelector('.vt-pagination'), clickable: true },
          breakpoints: {
            0: { slidesPerView: 3, slidesPerGroup: 1 },
            768: { slidesPerView: 3, slidesPerGroup: 1 },
            1024: { slidesPerView: 4, slidesPerGroup: 2 },
            1200: { slidesPerView: 6, slidesPerGroup: 2 }
          }
        });
        var prev = wrapper && wrapper.querySelector('.vt-prev');
        var next = wrapper && wrapper.querySelector('.vt-next');
        if (prev) {
          prev.onclick = function () {
            swiper.slidePrev();
          };
        }
        if (next) {
          next.onclick = function () {
            swiper.slideNext();
          };
        }
      });
      if (this.playBound) return;
      this.playBound = true;
      document.body.addEventListener('click', function (evt) {
        var button = evt.target.closest('.video-testimonials .custom-play-button');
        if (!button) return;
        var wrapper = button.closest('.video-wrapper');
        var video = wrapper ? wrapper.querySelector('video') : null;
        if (!video) return;
        document.querySelectorAll('.video-testimonials video').forEach(function (other) {
          if (other !== video) {
            other.pause();
            other.controls = false;
            var otherButton = other.parentElement.querySelector('.custom-play-button');
            if (otherButton) otherButton.style.display = 'block';
          }
        });
        video.play();
        video.controls = true;
        button.style.display = 'none';
        video.onpause = function () {
          button.style.display = 'block';
          video.controls = false;
        };
      });
    },
    readMore: function (el) {
      el.querySelectorAll('.testimonial-section').forEach(function (section) {
        if (section.dataset.bound) return;
        section.dataset.bound = 'true';
        var button = section.querySelector('.read-more-btn');
        var hidden = section.querySelectorAll('.hidden-review');
        if (!button || !hidden.length) return;
        button.addEventListener('click', function () {
          if (window.innerWidth >= 768) return;
          var expanded = button.classList.contains('expanded');
          hidden.forEach(function (review) {
            review.classList.toggle('show', !expanded);
          });
          button.textContent = expanded ? button.dataset.moreLabel : button.dataset.lessLabel;
          button.classList.toggle('expanded', !expanded);
        });
      });
    }
  };

  if (!customElements.get('product-selector')) customElements.define('product-selector', ProductSelector);
  if (!customElements.get('countdown-bar')) customElements.define('countdown-bar', CountdownBar);

  if (!customElements.get('accordion-item')) customElements.define('accordion-item', AccordionItem);
  if (!customElements.get('image-grid')) customElements.define('image-grid', ImageGrid);
  if (!customElements.get('video-carousel')) customElements.define('video-carousel', VideoCarousel);
  if (!customElements.get('testimonial-slider')) customElements.define('testimonial-slider', TestimonialSlider);

  function init(scope) {
    MiniCart.init();
    Animations.init(scope);
    Pdp.init(scope);
    SubscriptionWidget.init();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (evt) {
    if (evt.target.querySelector('[data-cart-drawer]')) {
      MiniCart.isOpen = false;
      document.body.classList.remove('overflow-hidden-tablet');
    }
    init(evt.target);
  });
})();
